import styled from 'styled-components';

export const Panel = styled<{ bordered?: boolean }, 'div'>('div')`
  background: #fff;
  border: ${props => (props.bordered === false ? 'none' : '1px solid #e8e8e8')};
  border-radius: 2px;
  overflow: hidden;
`;



// WEBPACK FOOTER //
// ./src/components/Panel.tsx